interface PartnersReferrersI {
  [key: string]: PartnersReferrerSettingI;
}

interface PartnersReferrerSettingI {
  campaignStrategy:
    | 'none'
    | 'custom'
    | 'all'
    | 'middle'
    | 'between'
    | 'middle-bottom'
    | 'bottom'
    | 'external'
    | 'internal';
}

const PartnersReferrers: PartnersReferrersI = {
  finviz: {
    campaignStrategy: 'none',
  },
  newsbreak: {
    campaignStrategy: 'none',
  },
  newsbreakapp: {
    campaignStrategy: 'none',
  },
  robinhood: {
    campaignStrategy: 'bottom',
  },
};

export const isUrlHasPartnerReferrerUTMSource = (url: string): boolean => {
  if (!url) {
    return false;
  }

  return Object.keys(PartnersReferrers).some(referrer => url?.includes(`utm_source=${referrer}`));
};

export const getSettings = (utmKey: string) => {
  let setting: string | undefined = undefined;

  if (utmKey) {
    for (const settingKey in PartnersReferrers) {
      if (utmKey.includes(settingKey)) {
        setting = PartnersReferrers[settingKey].campaignStrategy;
        break;
      }
    }
  }

  return setting;
};

export const getCampaignStrategySetting = (partnerKey: string): string | null => {
  return PartnersReferrers[partnerKey]?.campaignStrategy || null;
};

export const getAllRefPartners = (): string[] => {
  return Object.keys(PartnersReferrers);
};

// google.com, news.google.com, google.co.uk, ...; Android Google (Discover) and Google News send android-app referrers
const REGWALL_EXEMPT_REFERRER_HOSTS = [
  /(^|\.)google(\.[a-z]{2,3}){1,2}$/,
  /^com\.google\.android\.(googlequicksearchbox|apps\.magazines)$/,
  /(^|\.)sofi\.com$/,
];

interface RegwallReferrerContext {
  currentUrl?: string;
  landingUrl?: string;
  referrerUrl?: string;
}

// The first page of a visit from Google or SoFi never gets the regwall; later pages in the same visit can.
export const isFirstPageFromRegwallExemptReferrer = ({
  currentUrl,
  landingUrl,
  referrerUrl,
}: RegwallReferrerContext): boolean => {
  if (!currentUrl || !landingUrl) return false;

  try {
    const landing = new URL(landingUrl);
    if (new URL(currentUrl).pathname !== landing.pathname) return false;
    if (landing.searchParams.get('utm_source') === 'sofi.com') return true;
    if (!referrerUrl) return false;

    const referrerHost = new URL(referrerUrl).hostname;
    return REGWALL_EXEMPT_REFERRER_HOSTS.some(host => host.test(referrerHost));
  } catch {
    return false;
  }
};

export const isLandingPageFromRegwallExemptReferrer = (): boolean => {
  if (typeof window === 'undefined') return false;

  // document.referrer and the navigation entry stay the same across client-side navigations;
  // a reload or back/forward keeps the old referrer, so only a fresh navigation is a landing
  const [navigation] = window.performance?.getEntriesByType?.('navigation') ?? [];
  if (navigation && 'type' in navigation && navigation.type !== 'navigate') return false;
  return isFirstPageFromRegwallExemptReferrer({
    currentUrl: window.location.href,
    landingUrl: navigation?.name || window.location.href,
    referrerUrl: document.referrer,
  });
};
